import { Grid, Typography } from "@mui/material";
import React from "react";

const StudentInfo = ({
  fulllname,
  nickname,
  course,
}: {
  fulllname: string;
  nickname: string;
  course: string;
}) => {
  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} sm={3}>
        <Typography variant="subtitle1">
          ชื่อ - นามสกุล : <b>{fulllname ?? "-"}</b>
        </Typography>
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography variant="subtitle1">
          ฉายา : <b>{nickname ?? "-"}</b>
        </Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Typography variant="subtitle1">
          หลักสูตร : <b>{course ?? "-"}</b>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default StudentInfo;
